import { useDisclosure } from '@chakra-ui/react';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  CONTENT_INNER_PX_SIZE,
  HEADER_ID,
  SIDEBAR_ID,
} from '@/components/templates/PageLayout';
import {
  CmBox,
  CmButton,
  CmCard,
  CmFixedTd,
  CmFlex,
  CmHeadingPagination,
  CmLabelAndInput,
  CmLabelAndMultipleReactSelect,
  CmLongLoading,
  CmMessageCard,
  CmScrollBox,
  CmTable,
  CmTableBodyRow,
  CmTableHeader,
  CmTbody,
  CmTd,
  CmText,
  CmThWithQuestionIcon,
  CmTooltip,
  MultipleReactSelectInput,
  ReactSingleSelectInput,
  SelectForm,
  useCounter,
} from '@/components/uiParts';
import { LIMIT_PER_PAGE } from '@/domain/models/Pagination';
import { useTargetsDomHeight, useTargetsDomWidth } from '@/hooks/Dom';
import { isAvailableFeature, redirect404Page } from '@/lib/AccessControl';
import { errorHandler } from '@/lib/ErrorHandler';
import { HttpError } from '@/lib/exception';
import { ommisionText } from '@/lib/util';
import { StoreManegementPageLayout } from '@/pages/store-management/components/Layout/StoreManegementPageLayout';
import { UberAuthBulkActivateV2Modal } from '@/pages/store-management/master-stores/components/Modal/UberAuthBulkActivateV2Modal';
import { MasterStoreEditSidebarForm } from '@/pages/store-management/master-stores/components/Sidebar/MasterStoreSidebarForm/MasterStoreEditSidebarForm';
import { MasterStoreNewSidebarForm } from '@/pages/store-management/master-stores/components/Sidebar/MasterStoreSidebarForm/MasterStoreNewSidebarForm';
import {
  CONNECT_DELIVERY_SERVICES,
  deliveryStoreIntegrationStatus,
  masterStoreForm,
  masterStoreTableThs,
  TargetSidebar,
} from '@/pages/store-management/master-stores/service';
import {
  MasterStoreFormError,
  validateBusinessName,
  validateName,
  validateStoreSidebarInput,
} from '@/pages/store-management/master-stores/validate';
import { routes } from '@/router';
import { useAssociateBrandList } from '@/services/AssociateBrand/hooks/list/useAssociateBrandList';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';
import { useStoreManagementAuthStoreList } from '@/services/StoreManagement/AuthStores/hooks';
import { useListIntegrationReadyDeliveryStore } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/hooks';
import { ListIntegrationReadyDeliveryStoreResponse } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/hooks/useListIntegrationReadyDeliveryStore';
import { useStoreManagementMasterStoreCreate } from '@/services/StoreManagement/MasterStores/hooks/create/useStoreManagementMasterStoreCreate';
import { useStoreManagementMasterStoreDelete } from '@/services/StoreManagement/MasterStores/hooks/delete/useStoreManagementMasterStoreDelete';
import {
  StoreManagementMasterStoreSearchList,
  useStoreManagementMasterStoreSearchList,
} from '@/services/StoreManagement/MasterStores/hooks/serachList/useStoreManagementMasterStoreSearchList';
import {
  StoreManagementMasterStoreShowReqponse,
  useStoreManagementMasterStoreShow,
} from '@/services/StoreManagement/MasterStores/hooks/show/useStoreManagementMasterStoreShow';
import {
  StoreManagementMasterStoreUpdateParams,
  useStoreManagementMasterStoreUpdate,
} from '@/services/StoreManagement/MasterStores/hooks/update/useStoreManagementMasterStoreUpdate';

export const SEARCH_AREA_ID = 'search-form';
const ADD_BRAND = 'addbrand';
const ADD_BRAND_OPTION = {
  label: '＋新しいブランドの追加',
  value: ADD_BRAND,
} as const;

// 店舗情報変更の実装が全て完了するまで、Stores.tsxを残しておきたいので新しいファイルを作成して実装を行う
const StoreManagementMasterStoresPage: React.FC = (): JSX.Element | null => {
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  // /* アクセス制御 */
  redirect404Page('store_management', history, managerAccountMe);
  const [masterStores, setMasterStores] = useState<
    StoreManagementMasterStoreSearchList[]
  >([]);

  const [sidebarMasterStoreId, setSidebarMasterStoreId] = useState<number>(0);
  const [name, setName] = useState<string>('');
  const [searchCount, setSearchCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchAuthStores, setSearchAuthStores] = useState<SelectForm[]>([]);
  const [authStoreOptions, setAuthStoreOptions] = useState<SelectForm[]>([]);
  const [associateBrandOptions, setAssociateBrandOptions] = useState<
    SelectForm[]
  >([]);
  const [searchAssociateBrands, setSearchAssociateBrands] = useState<
    SelectForm[]
  >([]);
  const [targetSidebar, setTargetSidebar] = useState<TargetSidebar>('new');
  const [integrationReadyDeliveryStores, setIntegrationReadyDeliveryStores] =
    useState<ListIntegrationReadyDeliveryStoreResponse[]>([]);

  // ページネーションのページ
  const {
    count: currentPage,
    decrement,
    increment,
    customizeCount,
  } = useCounter(1);
  const [timer, setTimer] = useState<number>();
  const { targetsHeight } = useTargetsDomHeight([HEADER_ID, SEARCH_AREA_ID]);
  const errorObj = { message: '', isError: false, isTouched: false };
  const [masterStoreName, setMasterStoreName] = useState<string>('');
  const [masterStoreBusinessNumber, setMasterStoreBusinessNumber] =
    useState<string>('');
  const [masterStoreBusinessName, setMasterStoreBusinessName] =
    useState<string>('');
  const [targetMasterStore, setTargetMasterStore] =
    useState<StoreManagementMasterStoreShowReqponse>();
  const [hasCamelOrderSite, setHasCamelOrderSite] = useState(false);
  const [hasCamelCall, setHasCamelCall] = useState(false);
  const initialErrorObj = {
    name: { ...errorObj },
    authStore: { ...errorObj },
    associateBrand: { ...errorObj },
    businessNumber: { ...errorObj },
    businessName: { ...errorObj },
  };
  const [error, setError] = useState<MasterStoreFormError>({
    ...initialErrorObj,
  });

  const {
    isOpen: isSidebarOpen,
    onOpen: handleOpenSidebar,
    onClose,
  } = useDisclosure();

  const resetMasterStoreForm = () => {
    setMasterStoreName('');
    setMasterStoreBusinessNumber('');
    setMasterStoreBusinessName('');
    associateBrandSelectInput.onReset();
    authStoreSelectInput.onReset();
  };

  const handleCloseSidebar = () => {
    resetMasterStoreForm();
    onClose();
  };

  const {
    isOpen: IsOpenCreateAssociateBrandModal,
    onClose: handleCloseCreateAssociateBrandModal,
    onOpen: handleOpenCreateAssociateBrandModal,
  } = useDisclosure();
  const [
    targetAssociateBrandSelectForSidebar,
    setTargetAssociateBrandSelectForSidebar,
  ] = useState<SelectForm | null>({ label: '', value: '' });
  const [targetAuthStoreSelectForSidebar, setTargetAuthStoreSelectForSidebar] =
    useState<SelectForm | null>({ label: '', value: '' });

  const associateBrandSelectInput: ReactSingleSelectInput = {
    value: targetAssociateBrandSelectForSidebar,
    options: [ADD_BRAND_OPTION, ...associateBrandOptions],
    onChange: async (associateBrand: SelectForm | null) => {
      if (
        associateBrand === null ||
        associateBrand.value === targetAssociateBrandSelectForSidebar?.value
      )
        return;
      if (associateBrand.value === ADD_BRAND) {
        return handleOpenCreateAssociateBrandModal();
      }
      const copyError = { ...error };
      copyError.associateBrand.isError = false;
      setError(copyError);
      setTargetAssociateBrandSelectForSidebar(associateBrand);
    },
    onReset: () =>
      setTargetAssociateBrandSelectForSidebar({ value: '', label: '' }),
  };

  const authStoreSelectInput: ReactSingleSelectInput = {
    value: targetAuthStoreSelectForSidebar,
    options: authStoreOptions,
    onChange: async (authStore: SelectForm | null) => {
      if (
        authStore === null ||
        authStore.value === targetAuthStoreSelectForSidebar?.value
      )
        return;
      const copyError = { ...error };
      copyError.authStore.isError = false;
      setError(copyError);
      setTargetAuthStoreSelectForSidebar(authStore);
    },
    onReset: () => setTargetAuthStoreSelectForSidebar({ value: '', label: '' }),
  };

  const addCreatedAssociateBrandToSelectBox = (associateBrand: SelectForm) => {
    setAssociateBrandOptions((prev) => [associateBrand, ...prev]);
    setTargetAssociateBrandSelectForSidebar(associateBrand);
  };

  const getListQuery = {
    currentPage: 1,
    limit: LIMIT_PER_PAGE,
    name,
    authStoreIds: searchAuthStores.map((as) => Number(as.value)),
    associateBrandIds: [],
  };

  const refetchMasterStoresAndSet = async () => {
    const { master_stores, count } =
      await useStoreManagementMasterStoreSearchList({
        ...getListQuery,
        // 再fetchの際はページネーションはそのままなのでpageCountをそのまま使う。
        currentPage,
      });
    setSearchCount(count);
    setMasterStores(master_stores);

    const integrationReadyDeliveryStores =
      await useListIntegrationReadyDeliveryStore();
    setIntegrationReadyDeliveryStores(integrationReadyDeliveryStores);
  };

  const handleInputName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.value;
    setName(name);
    clearTimeout(Number(timer));
    const newTimer = setTimeout(async () => {
      setIsLoading(true);
      const { master_stores, count } =
        await useStoreManagementMasterStoreSearchList({
          ...getListQuery,
          currentPage: 1,
          name,
        });
      customizeCount(1);
      setSearchCount(count);
      setMasterStores(master_stores);
      setIsLoading(false);
    }, 700);
    setTimer(Number(newTimer));
  };

  const searchAuthStoresSelectInput: MultipleReactSelectInput = {
    value: searchAuthStores,
    options: authStoreOptions,
    onChange: async (authStores) => {
      setIsLoading(true);
      setSearchAuthStores([...authStores]);
      const { master_stores, count } =
        await useStoreManagementMasterStoreSearchList({
          ...getListQuery,
          authStoreIds: authStores.map((as) => Number(as.value)),
        });
      customizeCount(1);
      setSearchCount(count);
      setMasterStores(master_stores), setIsLoading(false);
    },
    onReset: () => setSearchAuthStores([]),
  };

  const searchAssociateBrandsSelectInput: MultipleReactSelectInput = {
    value: searchAssociateBrands,
    options: associateBrandOptions,
    onChange: async (brands) => {
      setIsLoading(true);
      setSearchAssociateBrands([...brands]);
      const { master_stores, count } =
        await useStoreManagementMasterStoreSearchList({
          ...getListQuery,
          associateBrandIds: brands.map((as) => Number(as.value)),
        });
      customizeCount(1);
      setSearchCount(count);
      setMasterStores(master_stores), setIsLoading(false);
    },
    onReset: () => setSearchAuthStores([]),
  };

  /* ページネーション */
  const toFirstPage = async () => {
    setIsLoading(true);
    const { master_stores } = await useStoreManagementMasterStoreSearchList({
      ...getListQuery,
    });
    setMasterStores(master_stores), customizeCount(1), setIsLoading(false);
  };

  const toPreviousPage = async () => {
    setIsLoading(true);
    const previousPage = currentPage - 1;
    const { master_stores } = await useStoreManagementMasterStoreSearchList({
      ...getListQuery,
      currentPage: previousPage,
    });
    setMasterStores(master_stores), decrement(), setIsLoading(false);
  };

  const toNextPage = async () => {
    setIsLoading(true);
    const nextPage = currentPage + 1;
    const { master_stores } = await useStoreManagementMasterStoreSearchList({
      ...getListQuery,
      currentPage: nextPage,
    });
    setMasterStores(master_stores), increment(), setIsLoading(false);
  };

  const toLastPage = async () => {
    setIsLoading(true);
    const lastPage = Math.ceil(searchCount / LIMIT_PER_PAGE);
    const { master_stores } = await useStoreManagementMasterStoreSearchList({
      ...getListQuery,
      currentPage: lastPage,
    });
    setMasterStores(master_stores),
      customizeCount(lastPage),
      setIsLoading(false);
  };

  const handleOpenNewSideBar = () => {
    if (targetSidebar === 'edit') resetMasterStoreForm();
    setTargetSidebar('new'), handleOpenSidebar();
    setTargetMasterStore(undefined);
  };

  const handleOpenEditSideBar = async (masterStoreId: number) => {
    setSidebarMasterStoreId(masterStoreId);
    const targetMasterStore = await useStoreManagementMasterStoreShow(
      masterStoreId
    );
    setTargetMasterStore(targetMasterStore);
    setTargetSidebar('edit'), handleOpenSidebar();
    setError({ ...initialErrorObj });
  };

  const handleInputMasterStoreName = (e: ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    const newError = validateName(newName, error);
    setError(newError);
    setMasterStoreName(e.target.value);
  };

  const handleInputMasterStoreBusinessNumber = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    setError({
      ...error,
      businessNumber: {
        isTouched: true,
        message: '',
        isError: false,
      },
    });
    setMasterStoreBusinessNumber(e.target.value);
  };

  const handleInputMasterStoreBusinessName = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const newName = e.target.value;
    const newError = validateBusinessName(newName, error);
    setError(newError);
    setMasterStoreBusinessName(e.target.value);
  };

  const handleCreateStore = async () => {
    // 最終確認のバリデーション
    const newError = { ...error };
    const isError = validateStoreSidebarInput(
      masterStoreName,
      authStoreSelectInput.value?.value ?? '',
      associateBrandSelectInput.value?.value ?? '',
      masterStoreBusinessName,
      newError
    );
    if (isError) {
      setError(newError);
      return alert(
        '不正な入力内容が確認されました。入力内容をご確認ください。'
      );
    }
    setError(initialErrorObj);
    try {
      const { id: masterStoreId } = await useStoreManagementMasterStoreCreate({
        name: masterStoreName,
        auth_store_id: Number(authStoreSelectInput.value?.value ?? 0),
        associate_brand_id: Number(associateBrandSelectInput.value?.value ?? 0),
        business_number:
          masterStoreBusinessNumber !== '' ? masterStoreBusinessNumber : null,
        business_name:
          masterStoreBusinessName !== '' ? masterStoreBusinessName : null,
      });
      alert('店舗を登録しました。');
      await refetchMasterStoresAndSet();
      // has_camel_order_siteを取得するための再fetchをしている。
      const targetMasterStore = await useStoreManagementMasterStoreShow(
        masterStoreId
      );
      setTargetMasterStore(targetMasterStore);
      setSidebarMasterStoreId(masterStoreId);
      setHasCamelOrderSite(targetMasterStore.has_camel_order_site);
      setHasCamelCall(targetMasterStore.has_camel_call);
      setTargetSidebar('edit');
    } catch (error) {
      if (error instanceof HttpError && error.status === 400) {
        setIsLoading(false);
        return alert(error.message);
      }
      // @ts-ignore TS2322
      errorHandler({ error });
    }
  };

  const handleUpdateStore = async (
    params: StoreManagementMasterStoreUpdateParams
  ) => {
    // 最終確認のバリデーション
    const newError = { ...error };
    const isError = validateStoreSidebarInput(
      masterStoreName,
      authStoreSelectInput.value?.value ?? '',
      associateBrandSelectInput.value?.value ?? '',
      masterStoreBusinessName,
      newError
    );
    if (isError) {
      setError(newError);
      return alert(
        '不正な入力内容が確認されました。入力内容をご確認ください。'
      );
    }
    try {
      await useStoreManagementMasterStoreUpdate(sidebarMasterStoreId, params);
      alert('店舗を更新しました。');
      await refetchMasterStoresAndSet();
      setIsLoading(false);
      handleCloseSidebar();
    } catch (error) {
      if (error instanceof HttpError && error.status === 400) {
        setIsLoading(false);
        return alert(error.message);
      }
      // @ts-ignore TS2322
      errorHandler({ error });
    }
  };

  const handleDeleteStore = async () => {
    const checkDelete = confirm('店舗を削除しますか？');
    if (!checkDelete) {
      return;
    }

    try {
      await useStoreManagementMasterStoreDelete(sidebarMasterStoreId);
      alert('店舗を削除しました。');
      await refetchMasterStoresAndSet();
      setIsLoading(false);
      handleCloseSidebar();
    } catch (error) {
      if (error instanceof HttpError && error.status === 400) {
        setIsLoading(false);
        return alert(error.message);
      }
      // @ts-ignore TS2322
      errorHandler({ error });
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const [
        { master_stores, count },
        authStores,
        integrationReadyDeliveryStores,
        associateBrands,
      ] = await Promise.all([
        useStoreManagementMasterStoreSearchList({
          ...getListQuery,
        }),
        useStoreManagementAuthStoreList(),
        useListIntegrationReadyDeliveryStore(),
        useAssociateBrandList(),
      ]);
      const authStoresOptions = authStores.map<SelectForm>((as) => ({
        value: as.id.toString(),
        label: as.name,
      }));
      setAuthStoreOptions(authStoresOptions);
      const associateBrandOptions = associateBrands.map<SelectForm>(
        (brand) => ({
          value: brand.id.toString(),
          label: brand.name,
        })
      );
      setAssociateBrandOptions(associateBrandOptions);
      setIntegrationReadyDeliveryStores(integrationReadyDeliveryStores);
      customizeCount(1);
      setMasterStores(master_stores);
      setSearchCount(count);
      setIsLoading(false);
    })();
  }, []);

  const { targetsWidth: sidebarWidth } = useTargetsDomWidth([SIDEBAR_ID]);

  // 店内飲食のアップセルのため利用可否を判定
  const isAvailableEatin = isAvailableFeature(
    'camel_order_eatin',
    managerAccountMe
  );

  const formComponsent = {
    new: (
      <MasterStoreNewSidebarForm
        {...{
          error,
          masterStoreName,
          masterStoreBusinessNumber,
          masterStoreBusinessName,
          isLoading,
          IsOpenCreateAssociateBrandModal,
          isSidebarOpen,
          associateBrandSelectInput,
          authStoreSelectInput,
          handleCloseSidebar,
          handleInputMasterStoreName,
          handleInputMasterStoreBusinessNumber,
          handleInputMasterStoreBusinessName,
          addCreatedAssociateBrandToSelectBox,
          handleCloseCreateAssociateBrandModal,
          handleCreateStore,
        }}
      />
    ),
    edit: (
      <MasterStoreEditSidebarForm
        {...{
          error,
          targetMasterStore,
          masterStoreName,
          masterStoreBusinessNumber,
          masterStoreBusinessName,
          sidebarMasterStoreId,
          isSidebarOpen,
          hasCamelOrderSite,
          hasCamelCall,
          isAvailableEatin,
          associateBrandSelectInput,
          authStoreSelectInput,
          setError,
          setHasCamelOrderSite,
          setHasCamelCall,
          setMasterStoreName,
          setMasterStoreBusinessNumber,
          setMasterStoreBusinessName,
          handleCloseSidebar,
          handleDeleteStore,
          handleInputMasterStoreName,
          handleInputMasterStoreBusinessNumber,
          handleInputMasterStoreBusinessName,
          handleUpdateStore,
          refetchMasterStoresAndSet,
          integrationReadyDeliveryStores,
        }}
      />
    ),
  }[targetSidebar];

  return (
    <StoreManegementPageLayout
      title={routes.storeManagementMasterStores.title}
      {...{ formComponsent }}
    >
      <CmBox>
        <CmBox padding="20px 20px 20px 0" id={SEARCH_AREA_ID}>
          <CmFlex alignItems="flex-end" justifyContent="space-between" w="full">
            <CmFlex width="full" justifyContent="space-between">
              <CmBox width="32%">
                <CmLabelAndInput
                  bg="white"
                  id="name"
                  label={masterStoreForm.name.label}
                  fontWeight="bold"
                  value={name}
                  onChange={handleInputName}
                />
              </CmBox>
              <CmBox width="32%">
                <CmLabelAndMultipleReactSelect
                  isOptionScroll
                  label="拠点"
                  fontWeight="bold"
                  name="authStoreName"
                  selectInput={searchAuthStoresSelectInput}
                />
              </CmBox>
              <CmBox width="32%">
                <CmLabelAndMultipleReactSelect
                  isOptionScroll
                  fontWeight="bold"
                  label="ブランド"
                  name="brand Name"
                  selectInput={searchAssociateBrandsSelectInput}
                />
              </CmBox>
            </CmFlex>
          </CmFlex>
          <CmFlex justifyContent="space-between" mt={'10px'}>
            <CmFlex>
              {/*
               // @ts-ignore TS2590 */}
              <CmButton onClick={() => handleOpenNewSideBar()} mr="20px">
                新規追加
              </CmButton>
              <UberAuthBulkActivateV2Modal />
            </CmFlex>

            <CmBox width="40%" textAlign="right">
              件数: {searchCount} 件
            </CmBox>
          </CmFlex>
        </CmBox>

        {masterStores.length > 0 ? (
          <CmCard
            padding="20px"
            height={`calc(100vh - ${targetsHeight}px - 20px)`}
            w={`calc(100vw - ${sidebarWidth + CONTENT_INNER_PX_SIZE * 2}px)`}
          >
            <CmFlex flexDirection="row-reverse" my="5px">
              <CmHeadingPagination
                totalNum={searchCount}
                LimitPerPage={LIMIT_PER_PAGE}
                {...{
                  currentPage,
                  toFirstPage,
                  toNextPage,
                  toPreviousPage,
                  toLastPage,
                }}
              />
            </CmFlex>
            <CmScrollBox>
              <CmTable>
                <CmTableHeader>
                  {masterStoreTableThs.map((th, index) => {
                    const style = {
                      minWidth: th.minWidth,
                      left: index === 0 ? '0' : undefined,
                      zIndex: index === 0 ? '2' : undefined,
                    } as const;
                    return (
                      <CmThWithQuestionIcon
                        key={th.label}
                        {...style}
                        label={th.label}
                        question={th.question}
                      />
                    );
                  })}
                </CmTableHeader>
                <CmTbody>
                  {masterStores.map((masterStore, index) => {
                    const {
                      id,
                      name,
                      auth_store_name,
                      brand_name,
                      delivery_stores,
                    } = masterStore;
                    return (
                      <CmTableBodyRow key={index + 1}>
                        <CmFixedTd {...{ left: '0' }}>
                          <CmBox
                            tabIndex={0}
                            cursor="pointer"
                            padding="5px"
                            onClick={() => handleOpenEditSideBar(id)}
                          >
                            <CmText color="blue.500">
                              <CmTooltip label={name}>
                                {ommisionText(name, 20)}
                              </CmTooltip>
                            </CmText>
                          </CmBox>
                        </CmFixedTd>
                        <CmTd>
                          <CmTooltip label={auth_store_name}>
                            {ommisionText(auth_store_name, 20)}
                          </CmTooltip>
                        </CmTd>
                        <CmTd textAlign="center">
                          <CmTooltip label={brand_name}>
                            {ommisionText(brand_name, 20)}
                          </CmTooltip>
                        </CmTd>
                        {CONNECT_DELIVERY_SERVICES.map((ds) => (
                          <CmTd textAlign="center" key={ds}>
                            {deliveryStoreIntegrationStatus(
                              delivery_stores,
                              ds
                            )}
                          </CmTd>
                        ))}
                      </CmTableBodyRow>
                    );
                  })}
                </CmTbody>
              </CmTable>
            </CmScrollBox>
          </CmCard>
        ) : (
          <>
            {!isLoading && (
              <CmMessageCard margin="100px auto 0">
                検索結果に一致する店舗が見当たりませんでした。
              </CmMessageCard>
            )}
          </>
        )}
        {isLoading && <CmLongLoading />}
      </CmBox>
    </StoreManegementPageLayout>
  );
};

export default StoreManagementMasterStoresPage;
